import { Tooltip } from "@mui/material";
import { useState } from "react";
import { ArrowUpward, ArrowDownward } from "@mui/icons-material";

const headerStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    textAlign: "left",
    fontWeight: "bold",
    fontSize: "14px",
    color: "#fff",
    cursor: "pointer",
};

const cellStyle = {
    border: "1px solid #ddd",
    padding: "10px",
    textAlign: "left",
    fontSize: "12px",
};

const TaskTable = ({ employeeData }) => {

    const data = employeeData?.project_details || [];


    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
    const [page, setPage] = useState(0);
    const rowsPerPage = 5;

    const handleSort = (key) => {
        let direction = "asc";
        if (sortConfig.key === key && sortConfig.direction === "asc") {
            direction = "desc";
        }
        setSortConfig({ key, direction });
    };

    const sortedData = [...data].sort((a, b) => {
        if (!sortConfig.key) return 0;
        const valA = a[sortConfig.key];
        const valB = b[sortConfig.key];
        if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
        if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
        return 0;
    });

    const paginatedData = sortedData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );

    return (
        <div
            style={{
                width: "100%",
                overflowX: "auto",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
            }}
        >
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                }}
            >
                <thead>
                    <tr style={{ background: "linear-gradient(135deg, #646987 0%, #646987 100%)" }}>
                        {[
                            { key: "projectCode", label: "Project Code" },
                            { key: "taskCode", label: "Task Code" },
                            { key: "milestone", label: "Milestone" },
                            { key: "module", label: "Module" },
                            { key: "startDate", label: "Start Date" },
                            { key: "endDate", label: "End Date" },
                            { key: "assignedHours", label: "Assigned Hours" },
                            { key: "actualHours", label: "Actual Hours" },
                            { key: "status", label: "Status" },
                        ].map((col) => (
                            <th
                                key={col.key}
                                style={headerStyle}
                                onClick={() => handleSort(col.key)}
                            >
                                {col.label}{" "}
                                {sortConfig.key === col.key ? (
                                    sortConfig.direction === "asc" ? (
                                        <ArrowUpward fontSize="small" />
                                    ) : (
                                        <ArrowDownward fontSize="small" />
                                    )
                                ) : null}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.length === 0 ? (
                        <tr>
                            <td colSpan={9} style={{ textAlign: "center", padding: "20px", fontSize: "14px", color: "#777", fontWeight: 'bold', fontFamily: 'sans-serif', fontStyle: 'italic' }}>
                                No Task Data Found <br/> Once the task is assigned to you, task details will be displayed here.
                            </td>
                        </tr>
                    ) : (
                        paginatedData.map((row, index) => (
                            <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                                <td style={cellStyle}>
                                    <Tooltip title={row.projectName} arrow>
                                        <span>{row.projectCode}</span>
                                    </Tooltip>
                                </td>
                                <td style={cellStyle}>
                                    <Tooltip title={row.taskName} arrow>
                                        <span>{row.taskCode}</span>
                                    </Tooltip>
                                </td>
                                <td style={cellStyle}>{row.milestone}</td>
                                <td style={cellStyle}>{row.module}</td>
                                <td style={cellStyle}>{row.startDate}</td>
                                <td style={cellStyle}>{row.endDate}</td>
                                <td style={cellStyle}>
                                    {row.actualHours > 0 ? row.assignedHours : "N/A"}
                                </td>
                                <td style={cellStyle}>{row.actualHours}</td>
                                <td style={cellStyle}>{row.status}</td>
                            </tr>
                        ))
                    )}
                </tbody>

            </table>


            <div style={{ marginTop: "10px", display: "flex", justifyContent: "flex-end" }}>
                <button
                    onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                    disabled={page === 0}
                    style={{ padding: "5px 10px", borderRadius: '4px' }}
                >
                    Previous
                </button>
                <span style={{ fontSize: '14px', margin: '0 10px', alignSelf: 'center' }}>
                    Page {page + 1} of {Math.ceil(sortedData.length / rowsPerPage)}
                </span>
                <button
                    onClick={() =>
                        setPage((prev) =>
                            prev < Math.ceil(sortedData.length / rowsPerPage) - 1 ? prev + 1 : prev
                        )
                    }
                    disabled={page >= Math.ceil(sortedData.length / rowsPerPage) - 1}
                    style={{ padding: "5px 10px", borderRadius: '4px' }}
                >
                    Next
                </button>
            </div>

            <style>
                {`
          div::-webkit-scrollbar {
            display: none;
          }
        `}
            </style>
        </div>
    );
};

export default TaskTable;
